export const flexGroup = ({ direction, alignItems, }) => ({
    display: "flex",
    flexDirection: direction ?? "row",
    alignItems,
});
export const DISABLED_CURSOR = "not-allowed";
